/**
 * Switch Component Styles
 */

import { mode } from '../../system/color-mode';

export const switchStyles = {
  baseStyle: {
    container: {},
    track: {
      display: 'flex',
      alignItems: 'center',
      boxSizing: 'border-box',
      w: '40px',
      h: '20px',
      p: '2px',
      ps: '2px',
      borderRadius: 'full',
      transition: 'all 120ms',
      bg: 'gray.200',
      _focus: {
        boxShadow: 'none',
      },
      _checked: {
        bg: 'brand.500',
      },
      _disabled: {
        opacity: 0.4,
        cursor: 'not-allowed',
      },
    },
    thumb: {
      fontWeight: 400,
      borderRadius: '50%',
      w: '16px',
      h: '16px',
      bg: 'white',
      transition: 'transform 250ms',
      _checked: {
        transform: 'translateX(20px)',
      },
    },
  },

  sizes: {
    sm: {
      track: {
        w: '1.375rem',
        h: '0.75rem',
      },
      thumb: {
        w: '0.5rem',
        h: '0.5rem',
        _checked: {
          transform: 'translateX(0.625rem)',
        },
      },
    },
    md: {
      track: {
        w: '1.875rem',
        h: '1rem',
      },
      thumb: {
        w: '0.75rem',
        h: '0.75rem',
        _checked: {
          transform: 'translateX(0.875rem)',
        },
      },
    },
    lg: {
      track: {
        w: '2.875rem',
        h: '1.5rem',
      },
      thumb: {
        w: '1.25rem',
        h: '1.25rem',
        _checked: {
          transform: 'translateX(1.375rem)',
        },
      },
    },
  },

  variants: {
    main: (props) => ({
      track: {
        bg: mode('gray.300', 'navy.700')(props),
        _checked: {
          bg: mode('brand.500', 'brand.400')(props),
        },
      },
    }),
  },

  defaultProps: {
    size: 'md',
    colorScheme: 'brand',
  },
};

export default switchStyles;
